// checks if 24 hours have passed
const isNextDay = time => time + 86400000 < Date.now();

export default isNextDay;
